export default {"src":"/_next/static/media/instagramIcon.f9272138.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};